const rqrTypeEnum = Object.freeze({
    COMPLICE: 1,
    QUALITY: 2,
    IN_FLIGHT_REVIEW: 4,
});

export default rqrTypeEnum;